import CustomIntroSection from "../component/explainBuyPage/customIntroSection";
import BlockedItemsSection from "../component/explainBuyPage/blockedItemsSection";
import HowItWorksSections from "../component/explainBuyPage/howItWorksSection";
import AskSection from "../component/home/askSection";
import FooterUser from "../component/sharedComponents/footer";
import { useTranslation } from "react-i18next";
import TurkishAndEuropean from "../component/explainBuyPage/TurkishAndEuropean";
import BlockedItemsSliderSection from "../component/explainBuyPage/BlockedItemsSliderSection";
import CustomSpesificSEction from "../component/explainBuyPage/CustomSpesificSEction";
import Header from "../component/sharedComponents/header";
const ExplainBuyPage = () => {
  const { t } = useTranslation();

  return (
    <div className="">
      <Header/>
      <div className="mt-[55px] md:mt-[56px] lg:mt-[75px] ">
        <CustomSpesificSEction title={t("introSection.title")} />
      </div>
      <div className="block md:hidden">
        <BlockedItemsSliderSection header={true} />
      </div>

      <div className="hidden md:block">
        <BlockedItemsSection />
      </div>
      <TurkishAndEuropean />
      <HowItWorksSections />
      <AskSection />
      <FooterUser />
    </div>
  );
};

export default ExplainBuyPage;
